import { PRICE_RANGE_ENTRIES as PRE } from 'Constants'

export const resolveMinMax = data => {
  const prices = data.products.aggregations.prices
  const findMinimum = min => PRE.filter(item => item < min).length
  const findMaximum = max =>
    PRE.length - PRE.filter(item => item > max).length - 1
  return {
    min: findMinimum(prices.min),
    max: findMaximum(prices.max)
  }
}
